import React, { Component } from 'react'
import { AccountFeatures, AppContext, Features } from '@lightspeed-invoicing/core-client/frontend';
import { FormattedMessage, injectIntl, FormattedNumber, defineMessages } from 'react-intl'
import SideBar from '../common/layout/sidebar.component.jsx'
import "react-toggle/style.css"
import "./myAccount.scss"
import GlobalHelper from "../common/GlobalHelper.jsx";
import Icon from "../common/icon/icon.component.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import ChoosePlanFooter from './chooseplanfooter.component.jsx';
import ShopifyAppContext from '../shopify/shopifyappcontext.js';
import { Redirect } from '@shopify/app-bridge/actions';
import ChoosePlanAddon from './chooseplanaddon.component.tsx';
import ChoosePlanPlan from './chooseplanplan.component.jsx';
import { integrationKeyShopify, integrationKeyShopifyExpertApp, integrationKeyVend } from '../integration/IntegrationConstants.jsx'
import { getPriceListName } from '../name-helpers/priceListNameHelper'
import { capitalize } from '../name-helpers/nameFormatter'
import IntegrationConfigurationService from "../state/integration/IntegrationConfigurationService";
import { isError } from "../state/helpers/Error";
import ExtraAddonsTotal from './extraAddonsTotal.tsx';

const typeOfModal = { portal: "portal", hostedPage: "hostedPage" }

class ChoosePlan extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            selectedPlan: "",
            selectedAddonsMap: {},
            currency: props.currency ? props.currency : 'USD',
            plans: this.props.plans || [],
            addons: this.props.addons || [],
            subscription: this.props.subscription || {},
            intervalType: 'year',
            testMode: false,
            update: false,
            price: 0,
            priceWithLocations: 0,
            locationsNumber: 1,
            showHostedPage: false,
            showError: !this.props.isValid,
            errorMessage: '',
            priceWithExtraAddons: 0,
        }

        this.updatePlan = this.updatePlan.bind(this)
        this.updateTotal = this.updateTotal.bind(this)
        this.getPlans = this.getPlans.bind(this)
        this.choosePlan = this.choosePlan.bind(this)
        this.getModulesMessages = this.getModulesMessages.bind(this)
        this.chooseAddon = this.chooseAddon.bind(this)
        this.chooseAddonInput = this.chooseAddonInput.bind(this)
        this.locationChange = this.locationChange.bind(this)
        this.updateSubscriptionChargebeeSuccess = this.updateSubscriptionChargebeeSuccess.bind(this)
        this.freePlan = this.freePlan.bind(this)
        this.intercomMessage = this.intercomMessage.bind(this)
        this.getSubscription = this.getSubscription.bind(this)
        this.formatPrice = this.formatPrice.bind(this)
        this.getSelectedPlan = this.getSelectedPlan.bind(this)
        this.shopifyCreateSubscription = this.shopifyCreateSubscription.bind(this)
        this.vendCreateSubscription = this.vendCreateSubscription.bind(this)
        this.getErrorMessage = this.getErrorMessage.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.getSubscription()
    }

    getErrorMessage() {
        switch (this.state.errorMessage) {
            case "invalid_account_status":
                return <FormattedMessage
                    id="my-account.chooseplan.inactive_account_error"
                    defaultMessage="You can't activate a plan because your {integrationName} account is not active, reach out to our team for assistance"
                    values={{
                        'integrationName': this.state.subscription.integrationKey
                    }}
                />
            default:
                return <FormattedMessage
                    id="myaccount.chooseplan.default_error"
                    defaultMessage="Contact Support. Change plan panel not available."
                />
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.plans.length !== this.props.plans.length || prevProps.plans.length !== this.props.plans.length || prevProps.loading !== this.props.loading) {
            this.setState({
                plans: this.props.plans,
                addons: this.props.addons,
                subscription: this.props.subscription
            }, () => this.getSubscription())
        }
    }

    getSubscription() {
        let sub = this.state.subscription
        let selectedPlan = this.state.plans.find(p => p.id === sub.planId)
        this.setState({
            selectedPlan: sub.planId || "",
            selectedAddonsMap: sub.addonsMap || {},
            locationsNumber: sub.planQuantity || 1,
            intervalType: selectedPlan ? selectedPlan.attributes.intervalType : 'year',
        }, () => this.updateTotal())
    }

    locationChange(e) {
        e.preventDefault()
        let value = e.target.value
        let selectedAddonsMap = Object.assign({}, this.state.selectedAddonsMap)
        if (parseInt(value) > 0) {
            value = parseInt(value)
        } else {
            value = 0
        }

        Object.keys(selectedAddonsMap).map(key => {
            let addon = this.state.addons.find(i => i.id == key)
            if (key && addon && !addon.attributes.modifiedQMAttribute) {
                selectedAddonsMap[key] = value.toString()
            }
        })

        this.setState({
            locationsNumber: value,
            selectedAddonsMap: selectedAddonsMap,
        }, () => this.updateTotal())
    }

    intercomMessage(event) {
        event.preventDefault()
        if (window.Intercom) {
            window.Intercom('show')
        }
    }

    selectedPlanHasAddonsAsApplicable(selectedPlanElem, a) {
        return selectedPlanElem && selectedPlanElem.applicable_addons && selectedPlanElem.applicable_addons.filter(add => add == a.id).length > 0
    }

    isAddonWithQuantity(addon) {
        return addon.attributes.modifiedQMAttribute
    }

    updateTotal() {
        let totalPrice = 0
        const plan = this.getPlans().find(p => p.id === this.state.selectedPlan)
        if (!plan) {
            return
        }
        totalPrice = totalPrice + this.formatPrice(plan.price)

        const addonsPriceReducer = (accumulator, currentValue) => accumulator + this.formatPrice(currentValue.attributes.price);
        const addonsPriceReducerWithQty = (accumulator, currentValue) => accumulator + (this.formatPrice(currentValue.attributes.price) * parseInt(this.state.selectedAddonsMap[currentValue.id]));
        const addons = this.state.addons.filter(a => Object.keys(this.state.selectedAddonsMap).includes(a.id) && !a.attributes.modifiedQMAttribute)
        const extraAddons = this.state.addons.filter(a => Object.keys(this.state.selectedAddonsMap).includes(a.id) && a.attributes.modifiedQMAttribute)
        totalPrice = addons.reduce(addonsPriceReducer, totalPrice)
        let totalExtraAddons = extraAddons.reduce(addonsPriceReducerWithQty, 0)
        let priceWithloc = parseFloat(totalPrice) * parseInt(this.state.locationsNumber)

        this.setState({
            price: totalPrice,
            priceWithLocations: priceWithloc,
            priceWithExtraAddons: priceWithloc + totalExtraAddons,
        })
    }


    getModulesMessages() {
        return [
            {
                module: AccountFeatures.FeatureRemovePaymentButton,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.advanced_payment_templates"
                    defaultMessage="Advanced payment templates"
                />,
                hidden: !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures(),
            },
            {
                module: AccountFeatures.FeatureSubscriptions,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.subscription"
                    defaultMessage="Recurring Invoices"
                />,
                hidden: !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures(),
            },
            {
                module: AccountFeatures.FeatureIntegratedBankTransfer,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.integrated_bank_transfer"
                    defaultMessage="Integrated Bank Transfer"
                />,
                hidden: !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures(),
            },
            {
                module: AccountFeatures.FeatureAccountStatements,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.account_statement"
                    defaultMessage="Account Statement"
                />
            },
            {
                module: AccountFeatures.FeatureStatementAutomation,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.account_statement_automation"
                    defaultMessage="Account Statement Automation"
                />
            },
            {
                module: AccountFeatures.FeatureScheduling,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.scheduling"
                    defaultMessage="Scheduling"
                />
            },
            {
                module: AccountFeatures.FeatureDigitalSignature,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.digital_signature"
                    defaultMessage="Digital signature"
                />
            },
            {
                module: AccountFeatures.FeaturePriceList,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.price_list_feature"
                    defaultMessage="{priceList}"
                    values={{
                        priceList: capitalize(getPriceListName(this.props.intl))
                    }}
                />
            },
            {
                module: AccountFeatures.FeatureIncludePdfAttachmentInInvoice,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.include_pdf_attachment"
                    defaultMessage="Include pdf attachment"
                />
            },
            {
                module: AccountFeatures.FeatureBranding,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.branding"
                    defaultMessage="Hide Branding"
                />
            },
            {
                module: AccountFeatures.FeatureOrder,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.sales_order"
                    defaultMessage="Sales order"
                />
            },
            {
                module: AccountFeatures.FeatureCustomEmail,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.custom_email_attachment"
                    defaultMessage="Custom email attachments"
                />
            },
            {
                module: AccountFeatures.FeatureBulkOperations,
                message: <FormattedMessage
                    id="myaccount.choose_plan.extra_module.bulk"
                    defaultMessage="Bulk document creation"
                />
            },
        ]
    }

    choosePlan(planId) {
        this.setState({
            selectedPlan: planId,
            selectedAddonsMap: {},
        }, () => this.updateTotal())
    }

    getSelectedPlan() {
        return this.getPlans().find(p => p.id === this.state.selectedPlan)
    }

    chooseAddon(addonId) {
        let selectedAddonsMap = Object.assign({}, this.state.selectedAddonsMap)
        if (Object.keys(selectedAddonsMap).includes(addonId)) {
            if (selectedAddonsMap.hasOwnProperty(addonId)) {
                delete selectedAddonsMap[addonId]
            }
        } else {
            selectedAddonsMap[addonId] = this.state.locationsNumber.toString()
        }

        this.setState({ selectedAddonsMap: selectedAddonsMap }, () => this.updateTotal())
    }

    chooseAddonInput(addonId, quantityEvent) {
        let selectedAddonsMap = Object.assign({}, this.state.selectedAddonsMap)
        let numberValue = parseInt(quantityEvent)
        if (!isNaN(numberValue) && numberValue > 0) {
            selectedAddonsMap[addonId] = quantityEvent
        } else {
            if (selectedAddonsMap.hasOwnProperty(addonId)) {
                delete selectedAddonsMap[addonId]
            }
        }

        this.setState({ selectedAddonsMap: selectedAddonsMap }, () => this.updateTotal())
    }

    updatePlan(e, freePlan) {
        if (GlobalHelper.integrationSupportsExternalSubscription(this.state.subscription.integrationKey)) {
            this.createExternalSubscription(this.state.subscription.integrationKey)
            return
        }

        if (!freePlan) {
            this.setState({ showHostedPage: true, showError: false })
        }
        let newData = {
            planId: this.state.selectedPlan,
            id: this.state.subscription.id,
            addonsMap: this.state.selectedAddonsMap,
            planQuantity: parseInt(this.state.locationsNumber),
            type: typeOfModal.hostedPage
        }

        let chargebeeInstance = Chargebee.getInstance();
        Promise.all([AppContext.getApiClient().post('/accounts/billing/subscription-modals', newData)]).then(res => {
            if (res[0].error) {
                this.setState({
                    showHostedPage: false,
                    showError: true,
                })
                return
            } else {
                chargebeeInstance.openCheckout({
                    url: res[0].attributes.access_url, step: (step) => {
                        if (step === "thankyou_screen") {
                            this.updateSubscriptionChargebeeSuccess(newData)
                            chargebeeInstance.closeAll()
                            this.props.onFinishLoading(true)
                        }
                    }
                })
                this.setState({
                    showHostedPage: false,
                    showError: false
                })
            }
        })
        e.preventDefault()
    }

    updateSubscriptionChargebeeSuccess(newData) {
        Promise.all([AppContext.getApiClient().put("/accounts/billing/subscription-details", newData)]).then(res => {
            if (!res.error) {
                let subs = res[0].attributes
                this.setState({
                    subscription: subs || {},
                    selectedPlan: subs.planId || "",
                    selectedAddonsMap: subs.addonsMap || [],
                })
            }
        })
    }

    formatPrice(price) {
        return parseFloat(price) / 100
    }

    freePlan(e) {
        e.preventDefault()
        this.setState({
            selectedPlan: (this.getPlans().find(p => this.formatPrice(p.price) === 0)).id,
            selectedAddonsMap: [],
            locationsNumber: 1,
            price: 0,
            priceWithLocations: 0
        }, () => {
            this.updatePlan(e, true)
        })
    }

    getPlans() {
        let plans = []
        if (this.state.plans && this.state.plans.length > 0) {
            plans = this.state.plans.map(elem => {
                return elem.attributes
            })
        }
        return plans
    }

    createExternalSubscription(integrationKey) {
        IntegrationConfigurationService.ValidateAccountStatus(integrationKey).then(res => {
            if (isError(res) || !res.isValid) {
                this.setState({
                    showError: true,
                    errorMessage: "invalid_account_status"
                })
                window.history.pushState(this.state, 'QuoteMachine', `/my-account?subscription_error=non_active_${integrationKey}_plan`);
            } else {
                switch (integrationKey) {
                    case integrationKeyShopifyExpertApp:
                    case integrationKeyShopify:
                        this.shopifyCreateSubscription(integrationKey).then(_ => { })
                        break;
                    case integrationKeyVend:
                        this.vendCreateSubscription(integrationKey).then(_ => { })
                }
            }
        })
    }

    async shopifyCreateSubscription(integrationKey) {
        const shopifyOrigin = GlobalHelper.getShopifyIntegrationOrigin()
        let redirectPath = ""

        const options = AppContext.getOptions()
        let isTest = true;
        switch (options.environment) {
            case 'prod':
                isTest = false
                break
        }

        if (shopifyOrigin) {
            await ShopifyAppContext.setOrigin(shopifyOrigin)
        }
        if (window.self === window.top) {
            redirectPath = window.location.href
        } else {
            redirectPath = "https://" + ShopifyAppContext.origin + "/admin/apps/" + ShopifyAppContext.apiKey + "/my-account"
        }

        AppContext.getApiClient().post('/' + integrationKey + '/create-external-subscription', {
            "name": "QuoteMachine-Subscription",
            "price": this.state.priceWithExtraAddons.toString(),
            "return_url": redirectPath,
            "test": isTest,
            "planId": this.state.selectedPlan,
            "addonsMap": this.state.selectedAddonsMap,
            "chargebeeSubscriptionId": this.state.subscription.id,
            "quantity": this.state.locationsNumber.toString(),
            "interval": this.state.intervalType,
        }).then(r => {
            if (window.self === window.top) {
                window.location = r["confirmation_url"]
            } else {
                const redirect = Redirect.create(ShopifyAppContext.app);
                redirect.dispatch(Redirect.Action.REMOTE, r["confirmation_url"])
            }
        })
    }

    async vendCreateSubscription(integrationKey) {
        const options = AppContext.getOptions()
        let isTest = !(options.environment === 'prod')
        let tempPlan = this.state.plans.filter(p => p.id === this.state.selectedPlan)
        let currency = tempPlan.length > 0 ? tempPlan[0].attributes.currency : "USD"

        AppContext.getApiClient().post('/' + integrationKey + '/create-external-subscription', {
            "name": "QuoteMachine-Subscription",
            "price": this.state.priceWithLocations.toString(),
            "return_url": window.location.href,
            "test": isTest,
            "planId": this.state.selectedPlan,
            "addonsMap": this.state.selectedAddonsMap,
            "chargebeeSubscriptionId": this.state.subscription.id,
            "quantity": this.state.locationsNumber.toString(),
            "interval": this.state.intervalType,
            "currency": currency,
        }).then(r => {
            if (!r.error) {
                window.location = r["confirmation_url"]
            } else {
                this.setState({ showHostedPage: false })
            }
        })
    }

    render() {
        const plans = this.getPlans()
        const selectedPlanElem = plans.find(p => p.id === this.state.selectedPlan)
        const plan = plans.find(p => p.id === this.state.selectedPlan)
        const stripeUrl = AppContext.getOptions().apiUrl + '/openid/connect/stripe/' +
            AppContext.getUserLoggedIn().id + `?r=/my-account`

        let activationDisabled = false
        if (this.state.price === 0 && !GlobalHelper.hasActivePaymentIntegration()) {
            activationDisabled = true
        }
        if (!plan || this.state.locationsNumber < 1) {
            activationDisabled = true
        }
        return (
            <div className="ui-has-modules pt-0">
                <div className="row">
                    <div className="col-12 px-0">
                        <div className="flex flex-column">
                            <div className={"row justify-content-center"}>
                                <div className={"row mt-2"}>
                                    <div className={'col-12 text-center pb-3 mb-1'}>
                                        <div className="btn-group mr-2" role="group" >
                                            <button
                                                type="button"
                                                className={`btn btn-lg ${this.state.intervalType === "month" ? "btn-success" : "btn-secondary"}`}
                                                onClick={() => { this.setState({ intervalType: 'month', selectedPlan: "", selectedAddonsMap: [], locationsNumber: 1, price: 0, priceWithLocations: 0 }) }}
                                            >
                                                <FormattedMessage
                                                    id="myaccount.subscription.monthly"
                                                    defaultMessage="Billed Monthly"
                                                />
                                                {this.state.intervalType === 'month' ? <Icon className={'ml-1'} value={'check'} /> : ''}
                                            </button>
                                            {plans.filter(p => p.intervalType == 'year').length > 0 && <button
                                                type="button"
                                                className={"btn btn-lg " + (this.state.intervalType === 'year' ? 'btn-success' : 'btn-secondary')}
                                                onClick={() => { this.setState({ intervalType: 'year', selectedPlan: "", selectedAddonsMap: [], locationsNumber: 1, price: 0, priceWithLocations: 0 }) }}
                                            >
                                                <FormattedMessage
                                                    id="myaccount.subscription.yearly"
                                                    defaultMessage="Billed Yearly"
                                                />
                                                {this.state.intervalType === 'year' ? <Icon className={'ml-1'} value={'check'} /> : ''}
                                            </button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"row justify-content-center"}>
                                {plans.filter(p => p.intervalType === this.state.intervalType).length > 0 ?
                                    plans.filter(p => p.intervalType === this.state.intervalType && this.formatPrice(p.price) > 0).map((p, key) => {
                                        return <ChoosePlanPlan
                                            p={p}
                                            key={key}
                                            selectedPlan={this.state.selectedPlan}
                                            choosePlan={this.choosePlan}
                                            getModulesMessages={this.getModulesMessages}
                                            formatPrice={this.formatPrice}
                                            currency={this.state.currency}
                                        />
                                    }) : ""}
                            </div>

                        </div>
                    </div>
                </div>

                <div className={"row justify-content-center mt-4"}>
                    {this.state.addons.filter(a => a.attributes.intervalType === this.state.intervalType).length > 0 &&
                        this.state.addons.filter(a => a.attributes.intervalType === this.state.intervalType && !this.isAddonWithQuantity(a) && this.selectedPlanHasAddonsAsApplicable(selectedPlanElem, a)).map((a, key) => {
                            return <ChoosePlanAddon
                                a={a}
                                key={key}
                                selectedAddonsMap={this.state.selectedAddonsMap}
                                chooseAddon={this.chooseAddon}
                                chooseAddonInput={this.chooseAddonInput}
                                getModulesMessages={this.getModulesMessages}
                                formatPrice={this.formatPrice}
                                currency={this.state.currency}
                            />
                        })}
                </div>

                <div className={"row justify-content-center mt-4"}>
                    {this.state.addons.filter(a => a.attributes.intervalType === this.state.intervalType).length > 0 &&
                        this.state.addons.filter(a => a.attributes.intervalType === this.state.intervalType && this.isAddonWithQuantity(a) &&
                            this.selectedPlanHasAddonsAsApplicable(selectedPlanElem, a)).map((a, key) => {
                                return <ChoosePlanAddon
                                    a={a}
                                    key={key}
                                    selectedAddonsMap={this.state.selectedAddonsMap}
                                    chooseAddon={this.chooseAddon}
                                    chooseAddonInput={this.chooseAddonInput}
                                    getModulesMessages={this.getModulesMessages}
                                    formatPrice={this.formatPrice}
                                    currency={this.state.currency}
                                />
                            })}
                </div>

                <div className={"row justify-content-center mt-4"}>
                    <div className={'col-sm-6 col-md-6 col-lg-5 ui-module'}>
                        <div>
                            <div className={'row'}>
                                <div className={'col-12'}>
                                    <div className={'mb-0'}>
                                        <strong>
                                            <FormattedMessage
                                                id="myaccount.choose_plan.estimated_total"
                                                defaultMessage="Estimated Total*"
                                            />
                                        </strong>
                                    </div>

                                    <div className="d-flex mt-3 mb-3">
                                        <FormattedMessage
                                            id="myaccount.choose_plan.estimate_total_details_no_extra"
                                            defaultMessage="{subTotal} X {nbLocations} locations ({nbUsers} users)"
                                            values={{
                                                subTotal: <div className="d-inline-flex">
                                                    <div className="mr-1">
                                                        <FormattedNumber
                                                            style="currency"
                                                            maximumFractionDigits={0}
                                                            currencyDisplay={'symbol'}
                                                            currency={this.state.currency}
                                                            value={this.state.price}
                                                        />
                                                    </div>
                                                    <small>
                                                        {this.state.intervalType === 'year' ? <FormattedMessage
                                                            id="myaccount.choose_plan.per_year"
                                                            defaultMessage="per year"
                                                        /> : <FormattedMessage
                                                            id="myaccount.choose_plan.per_month"
                                                            defaultMessage="per month"
                                                        />}
                                                    </small>
                                                </div>,
                                                nbLocations: <input
                                                    value={this.state.locationsNumber}
                                                    min={1}
                                                    onChange={this.locationChange}
                                                    type="number"
                                                    style={{ "width": "60px" }}
                                                />,
                                                nbUsers: (this.getSelectedPlan() ? parseFloat(this.getSelectedPlan().maxNumberOfUsers) : 1) === 0 ?
                                                    <FormattedMessage
                                                        id="myaccount.choose_plan.unlimited"
                                                        defaultMessage="Unlimited"
                                                    /> :
                                                    <FormattedMessage
                                                        id="myaccount.choose_plan.up_to"
                                                        defaultMessage="Up to {nb}"
                                                        values={{ nb: this.getSelectedPlan() ? this.getSelectedPlan().maxNumberOfUsers * this.state.locationsNumber : 1 }}
                                                    />,
                                            }}
                                        />
                                    </div>

                                    <ExtraAddonsTotal
                                        addons={this.state.addons}
                                        selectedAddonsMap={this.state.selectedAddonsMap}
                                        currency={this.state.currency}
                                        formatPrice={this.formatPrice}
                                        intervalType={this.state.intervalType}
                                        priceWithExtraAddons={this.state.priceWithExtraAddons}
                                    />


                                    <h3 className={'custom-lead d-inline-flex'}>
                                        <FormattedMessage
                                            id="myaccount.choose_plan.estimate_extra_addon_total_details"
                                            defaultMessage="= {total}"
                                            values={{
                                                total: <div className="d-inline-flex">
                                                    <div className="mr-1">
                                                        <FormattedNumber
                                                            style="currency"
                                                            maximumFractionDigits={0}
                                                            currencyDisplay={'symbol'}
                                                            currency={this.state.currency}
                                                            value={this.state.priceWithExtraAddons}
                                                        />
                                                    </div>
                                                    <small>
                                                        {this.state.intervalType === 'year' ? <FormattedMessage
                                                            id="myaccount.choose_plan.per_year"
                                                            defaultMessage="per year"
                                                        /> : <FormattedMessage
                                                            id="myaccount.choose_plan.per_month"
                                                            defaultMessage="per month"
                                                        />}
                                                    </small>
                                                </div>
                                            }}
                                        />
                                    </h3>

                                    <div className={'text-secondary'}>
                                        <small>
                                            <FormattedMessage
                                                id="myaccount.choose_plan.tax_may_apply"
                                                defaultMessage="*Taxes may apply based on billing location"
                                            />
                                        </small>

                                    </div>
                                </div>
                            </div>

                            <div className={'row'}>
                                <div className={'col-12 text-center'}>
                                    <ActionButton
                                        disabled={activationDisabled || !this.props.isValid}
                                        className={"btn btn-lg btn-success"}
                                        type={"submit"}
                                        isLoading={this.state.showHostedPage}
                                        onClick={() => {
                                            this.updatePlan()
                                        }}
                                    >
                                        <Icon className={'mr-1'} value={'rocket'} />
                                        {this.state.update ? <FormattedMessage
                                            id="myaccount.choose_plan.activate_btn"
                                            defaultMessage="Activate your account"
                                        /> : <FormattedMessage
                                            id="myaccount.choose_plan.update_your_plan_btn"
                                            defaultMessage="Update your plan"
                                        />}
                                    </ActionButton>
                                    {this.state.showError &&
                                        <div className="mt-3 alert alert-danger " role="alert">
                                            {this.getErrorMessage()}
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!GlobalHelper.integrationSupportsExternalSubscription(this.state.subscription.integrationKey) &&
                    <ChoosePlanFooter
                        freePlan={this.freePlan}
                        stripeUrl={stripeUrl}
                        intercomMessage={this.intercomMessage}
                    />}

            </div>
        );
    }
}



export default injectIntl(ChoosePlan);



// WEBPACK FOOTER //
// ./src/my-account/chooseplan.component.jsx